import { Route, Routes } from "react-router-dom";
import Inactivities from "./Inactivities";
import InactivityCreateEdit from "./InactivityCreateEdit";

const index = () => {
	return (
		<Routes>
			<Route index element={<Inactivities />} />
			<Route path='/create' element={<InactivityCreateEdit />} />
			<Route path='/:id/edit' element={<InactivityCreateEdit />} />
		</Routes>
	);
};

export default index;
